

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-currency-conversion-lightbox.route', ['squid', 'xo-currency-conversion-lightbox.directive']).factory('$CurrencyConversionOptionsRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('CurrencyConversionOptionsRoute', {

            name: 'currencyConversionOptions',
            directive: 'xo-currency-conversion-lightbox',
            trackingData: {
                fptiState: 'guest_currency_conversion_lightbox',
                trackStateExit: false,
                pageQualifier: 'guest',
                buzname: {
                    'guest': {
                        'pagename': '%::fullpage-guest-currency-conversion-lightbox',
                        'pagename2': '%::fullpage-guest:member:hermes:',
                        'version': 'guest:%:'
                    }
                }
            },

            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/currencyConversion/route.js
// module id = ./components/xo-guest-components/src/guest/currencyConversion/route.js
// module chunks = 1